import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import _typeof from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/typeof";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

var _this2 = this;

import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.array.filter.js";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import cloneDeep from 'lodash/cloneDeep';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import { make } from 'vuex-pathify';
import Menu from '@/store/helpers/menu';
import { goDeeper } from '@/store/helpers/recursions';
import Vue from 'vue';
import { FIB } from '@/config/constants';
import moment from 'moment';
var MENU_INSIGHT_MODE = FIB.MENU_INSIGHT_MODE;
/*
 * The product structure needs explaining:
 *
 * allProducts => This is simply all products stored in an array - mutations to set this value
 * in the store should check the product reference to filter out duplicate products (this replaces
 * the old 'menuItems' array)
 *
 * productsByMajorGroup => This is for use by 'major group type' MI questions. Products are stored
 * according to the following hierarchy: 'major group ref' => array of products.
 *
 * productsByFamilyGroup => This is for use by 'family group type' MI questions.  Products are
 * stored according to the following hierarchy: 'family group ref' => 'major group ref' => array
 * of products.
 *
 * productsByType => This is for use by 'type type' MI questions. Products are stored according
 * to the following hierarchy: 'type id' => 'family group ref' => 'major group ref' => array
 * of products.
 *
 */

var defaultState = function defaultState() {
  return {
    downloadedProducts: {},
    allProducts: [],
    allProductsLoading: {},
    familyGroups: [],
    familyGroupsByType: {},
    familyGroupsLoading: {},
    familyGroupsByTypeLoading: {},
    majorGroups: [],
    majorGroupsByFamilyGroup: {},
    majorGroupsByFamilyGroupAndType: {},
    majorGroupsLoading: {},
    majorGroupsByFamilyGroupLoading: {},
    majorGroupsByFamilyGroupAndTypeLoading: {},
    productsByFamilyGroup: {},
    productsByFamilyGroupLoading: {},
    productsByMajorGroup: {},
    productsByMajorGroupLoading: {},
    productsByQuestion: {},
    productSearchResults: {},
    productsByTransaction: {},
    productsByTransactionLoading: {},
    productsByType: {},
    productsByTypeLoading: {},
    searchResultsLoading: {},
    searchWaitingRoom: {},
    types: []
  };
};

var state = defaultState();

var actions = _objectSpread(_objectSpread({}, make.actions(state)), {}, {
  // Make default actions

  /**
   * Fetch all menu data and store it - app
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Boolean}
   */
  exportMenuData: function exportMenuData(_ref) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, menuData, requests, index, payload, res;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref.commit;
              commit('resetState');
              menuData = {};
              requests = [{
                edge: 'products',
                store: 'allProducts'
              }, {
                edge: 'family_groups',
                store: 'familyGroups'
              }, {
                edge: 'major_groups',
                store: 'majorGroups'
              }];
              _context2.t0 = _regeneratorRuntime.keys(requests);

            case 5:
              if ((_context2.t1 = _context2.t0()).done) {
                _context2.next = 18;
                break;
              }

              index = _context2.t1.value;
              payload = {
                edge: requests[index].edge,
                limit: 2500,
                offset: 0
              };
              _context2.next = 10;
              return Menu.paginateThroughAllData( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this.$api.exportMenuData(payload);

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }(), payload);

            case 10:
              res = _context2.sent;

              if (!(res || {}).error) {
                _context2.next = 15;
                break;
              }

              return _context2.abrupt("return", false);

            case 15:
              menuData[requests[index].store] = res;

            case 16:
              _context2.next = 5;
              break;

            case 18:
              commit('addMenuData', menuData);
              commit('config/menuItemsLastUpdated', moment().unix(), {
                root: true
              });
              return _context2.abrupt("return", true);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },

  /**
   * Fetch all family groups via the API and set them in store.
   *
   * @param {Object} context Vuex module context
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Object} payload.familyGroupRef family group ref
   *
   * @returns {Void}
   */
  fetchFamilyGroups: function fetchFamilyGroups(_ref3, _ref4) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var commit, question, _ref4$familyGroupRef, familyGroupRef, payload, familyGroups;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              question = _ref4.question, _ref4$familyGroupRef = _ref4.familyGroupRef, familyGroupRef = _ref4$familyGroupRef === void 0 ? null : _ref4$familyGroupRef;
              // Always fetch if family groups requested
              payload = {
                limit: 2500
              }; // optionally add in a specific family group to fetch

              if (familyGroupRef) {
                payload.familyGroupRef = familyGroupRef;
              }

              commit('setFamilyGroupsLoading', {
                question: question,
                isLoading: true
              });
              _context3.next = 7;
              return Menu.getFamilyGroups(payload);

            case 7:
              familyGroups = _context3.sent;

              if (familyGroups) {
                commit('addToFamilyGroups', familyGroups);
              }

              commit('setFamilyGroupsLoading', {
                question: question,
                isLoading: false
              });

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },

  /**
   * Fetch all family groups via the API and set them in store.
   *
   * @param {Object} context Vuex module context
   * @param {Object} payload payload
   * @param {Object} payload.type product type
   *
   * @returns {Void}
   */
  fetchFamilyGroupsByType: function fetchFamilyGroupsByType(_ref5, _ref6) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var commit, getters, question, _ref6$familyGroupRef, familyGroupRef, type, payload, familyGroups;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref5.commit, getters = _ref5.getters;
              question = _ref6.question, _ref6$familyGroupRef = _ref6.familyGroupRef, familyGroupRef = _ref6$familyGroupRef === void 0 ? null : _ref6$familyGroupRef, type = _ref6.type;

              if (!getters.alreadyFetched({
                target: 'familyGroupsByType',
                refs: [type]
              })) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return");

            case 4:
              payload = {
                type: type,
                limit: 200 // TODO - this is only until pagination is implemented

              }; // optionally add in a specific family group to fetch

              if (familyGroupRef) {
                payload.familyGroupRef = familyGroupRef;
              }

              commit('setFamilyGroupsByTypeLoading', {
                question: question,
                isLoading: true
              });
              _context4.next = 9;
              return Menu.getFamilyGroups(payload);

            case 9:
              familyGroups = _context4.sent;
              commit('setFamilyGroupsByType', {
                type: type,
                familyGroups: familyGroups
              });
              commit('setFamilyGroupsByTypeLoading', {
                question: question,
                isLoading: false
              });

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },

  /**
   * Fetch all major groups via the API and set them in store.
   *
   * @param {Object} context Vuex module context
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Object} payload.majorGroupRef major group ref
   *
   * @returns {Void}
   */
  fetchMajorGroups: function fetchMajorGroups(_ref7, _ref8) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var commit, state, question, _ref8$majorGroupRef, majorGroupRef, payload, majorGroups;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref7.commit, state = _ref7.state;
              question = _ref8.question, _ref8$majorGroupRef = _ref8.majorGroupRef, majorGroupRef = _ref8$majorGroupRef === void 0 ? null : _ref8$majorGroupRef;
              payload = {
                limit: 200 // TODO - this is only until pagination is implemented

              }; // optionally add in a specific family group to fetch

              if (!majorGroupRef) {
                _context5.next = 7;
                break;
              }

              if (!state.majorGroups.find(function (v) {
                return v.ref = majorGroupRef;
              })) {
                _context5.next = 6;
                break;
              }

              return _context5.abrupt("return");

            case 6:
              payload.majorGroupRef = majorGroupRef;

            case 7:
              commit('setMajorGroupsLoading', {
                question: question,
                isLoading: true
              });
              _context5.next = 10;
              return Menu.getMajorGroups(payload);

            case 10:
              majorGroups = _context5.sent;

              if (majorGroups) {
                commit('addToMajorGroups', majorGroups);
              }

              commit('setMajorGroupsLoading', {
                question: question,
                isLoading: false
              });

            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },

  /**
   * Fetch major groups by family via the API and set them in store.
   *
   * @param {Object} context Vuex module context
   * @param {Object} payload payload
   * @param {Object} payload.familyGroup family group
   * @param {Object} payload.question menu insight question
   *
   * @returns {Void}
   */
  fetchMajorGroupsByFamilyGroup: function fetchMajorGroupsByFamilyGroup(_ref9, _ref10) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var commit, getters, familyGroup, question, majorGroupsByFamilyGroup, majorGroups, miscExist;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref9.commit, getters = _ref9.getters;
              familyGroup = _ref10.familyGroup, question = _ref10.question;

              if (!getters.alreadyFetched({
                target: 'majorGroupsByFamilyGroup',
                refs: [familyGroup.ref]
              })) {
                _context6.next = 4;
                break;
              }

              return _context6.abrupt("return");

            case 4:
              commit('setMajorGroupsByFamilyGroupLoading', {
                question: question,
                isLoading: true
              });
              _context6.next = 7;
              return Menu.getMajorGroups({
                familyGroupRef: familyGroup.ref
              });

            case 7:
              majorGroupsByFamilyGroup = _context6.sent;
              // ensure majorGroups is an array
              majorGroups = Array.isArray(majorGroupsByFamilyGroup) ? majorGroupsByFamilyGroup : []; // look for 'misc' products in family - if so, add a misc subcategory

              _context6.next = 11;
              return Menu.productsExist({
                familyGroupRef: familyGroup.ref,
                majorGroupRef: null
              });

            case 11:
              miscExist = _context6.sent;

              if (miscExist) {
                majorGroups.push({
                  // if family group mode, use family group name, not 'Misc'
                  name: familyGroup.name,
                  ref: 'misc' + familyGroup.ref,
                  isMisc: true
                });
              } // Logger.debug('major groups returned: ', majorGroups)


              commit('setMajorGroupsByFamilyGroup', {
                familyGroupRef: familyGroup.ref,
                majorGroups: majorGroups
              });
              commit('setMajorGroupsByFamilyGroupLoading', {
                question: question,
                isLoading: false
              });

            case 15:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },

  /**
   * Fetch major groups by family and type via the API and set them in store.
   *
   * @param {Object} context Vuex module context
   * @param {Object} payload payload
   * @param {Object} payload.familyGroup family group
   * @param {Object} payload.question menu insight question
   *
   * @returns {Void}
   */
  fetchMajorGroupsByFamilyGroupAndType: function fetchMajorGroupsByFamilyGroupAndType(_ref11, _ref12) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var commit, getters, familyGroup, question, type, majorGroupsByFamilyGroupAndType, majorGroups, miscExist;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref11.commit, getters = _ref11.getters;
              familyGroup = _ref12.familyGroup, question = _ref12.question;
              type = question === null || question === void 0 ? void 0 : question.menuType; // if already fetched, don't fetch again

              if (!getters.alreadyFetched({
                target: 'majorGroupsByFamilyGroupAndType',
                refs: [type, familyGroup.ref]
              })) {
                _context7.next = 5;
                break;
              }

              return _context7.abrupt("return");

            case 5:
              commit('setMajorGroupsByFamilyGroupAndTypeLoading', {
                question: question,
                isLoading: true
              });
              _context7.next = 8;
              return Menu.getMajorGroups({
                type: question.menuType,
                familyGroupRef: familyGroup.ref
              });

            case 8:
              majorGroupsByFamilyGroupAndType = _context7.sent;
              // ensure majorGroups is an array
              majorGroups = Array.isArray(majorGroupsByFamilyGroupAndType) ? majorGroupsByFamilyGroupAndType : []; // look for 'misc' products in family - if so, add a misc subcategory

              _context7.next = 12;
              return Menu.productsExist({
                familyGroupRef: familyGroup.ref,
                majorGroupRef: null,
                type: question.menuType
              });

            case 12:
              miscExist = _context7.sent;

              if (miscExist) {
                majorGroups.push({
                  // if family group mode, use family group name, not 'Misc'
                  name: familyGroup.name,
                  ref: 'misc' + familyGroup.ref,
                  isMisc: true
                });
              } // Logger.debug('major groups returned: ', majorGroups)


              commit('setMajorGroupsByFamilyGroupAndType', {
                familyGroupRef: familyGroup.ref,
                majorGroups: majorGroups,
                type: type
              });
              commit('setMajorGroupsByFamilyGroupAndTypeLoading', {
                question: question,
                isLoading: false
              });

            case 16:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },

  /**
   * Fetch all products by type via the API and set them in store.
   *
   * @param {Object} context Vuex module context
   * @param {Object} payload payload
   * @param {Object} payload.family family group
   * @param {Object} payload.majorGroup major group
   * @param {Object} payload.question menu insight question
   * @param {String} payload.question.menuType menu data type
   *
   * @returns {Void}
   */
  fetchProductsByType: function fetchProductsByType(_ref13, _ref14) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var commit, getters, familyGroup, majorGroup, question, type, isMisc, productsPayload, res, products;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              commit = _ref13.commit, getters = _ref13.getters;
              familyGroup = _ref14.familyGroup, majorGroup = _ref14.majorGroup, question = _ref14.question;
              type = question.menuType; // if already fetched, don't fetch again

              if (!getters.alreadyFetched({
                target: 'productsByType',
                refs: [type, familyGroup.ref, majorGroup.ref]
              })) {
                _context8.next = 5;
                break;
              }

              return _context8.abrupt("return");

            case 5:
              // reassign majorGroup with clone
              majorGroup = cloneDeep(majorGroup); // if ref 'misc', convert to null

              isMisc = majorGroup.isMisc;

              if (isMisc) {
                majorGroup.ref = null;
              }

              commit('setProductsByTypeLoading', {
                question: question,
                isLoading: true
              }); // get products

              productsPayload = {
                limit: 200,
                // TODO - this is only until pagination is implemented,
                offset: 0,
                type: type,
                familyGroupRef: familyGroup.ref,
                majorGroupRef: majorGroup.ref // text: null // only needed for text search, but leave here in case activated

              }; // fetch products from api

              _context8.next = 12;
              return Menu.getProducts(productsPayload);

            case 12:
              res = _context8.sent;

              // if misc, assign internal tracking reference to major group
              if (isMisc) {
                majorGroup.ref = 'misc' + familyGroup.ref;
              } // if products available, set in state


              if (res && Array.isArray(res.items)) {
                products = cloneDeep(res.items); // set products in both the cumulative allProducts array and by major and family groups

                commit('addToAllProducts', products);
                commit('addToProductsByQuestion', {
                  question: question,
                  products: products
                });
                commit('setProductsByType', {
                  familyGroup: familyGroup,
                  majorGroup: majorGroup,
                  products: products,
                  type: type
                });
              }

              commit('setProductsByTypeLoading', {
                question: question,
                isLoading: false
              });

            case 16:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },

  /**
   * Fetch all products by transaction via the API and set them in store.
   *
   * @param {Object} context Vuex module context
   * @param {Object} payload payload
   * @param {Object} payload.question menu insight question
   * @param {String} payload.transactionData any filters to apply to product fetch request
   *
   * @returns {Void}
   */
  fetchProductsByTransaction: function fetchProductsByTransaction(_ref15, _ref16) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var commit, getters, rootGetters, question, transactionData, filter, res, products;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit = _ref15.commit, getters = _ref15.getters, rootGetters = _ref15.rootGetters;
              question = _ref16.question, transactionData = _ref16.transactionData;

              if (!(!question || !transactionData)) {
                _context9.next = 4;
                break;
              }

              return _context9.abrupt("return");

            case 4:
              if (!getters.alreadyFetched({
                target: 'productsByTransaction',
                refs: [question.id]
              })) {
                _context9.next = 6;
                break;
              }

              return _context9.abrupt("return");

            case 6:
              // get products
              commit('setProductsByTransactionLoading', {
                question: question,
                isLoading: true
              }); // Filter down the data to only have products which were in the epos transaction, and match the mode/type of the MI question

              filter = pickBy({
                type: question.menuType,
                familyGroupRef: question.menuFamilyGroupRef,
                majorGroupRef: question.menuMajorGroupRef
              }, identity);
              filter.transactionProductRefs = rootGetters['checkIn/transactionProducts']().map(function (m) {
                return m.menuItemObjectNumber;
              }); // fetch products from api

              _context9.next = 11;
              return Menu.getProducts(_objectSpread({
                offset: 0,
                limit: 200
              }, filter));

            case 11:
              res = _context9.sent;

              // if products available, set in state
              if (res && Array.isArray(res.items)) {
                products = cloneDeep(res.items); // set products in both the cumulative allProducts array and by major and family groups

                commit('addToAllProducts', products);
                commit('addToProductsByQuestion', {
                  question: question,
                  products: products
                });
                commit('setProductsByTransaction', {
                  question: question,
                  products: products
                });
              }

              commit('setProductsByTransactionLoading', {
                question: question,
                isLoading: false
              });

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  },

  /**
   * Fetch all products by family group via the API and set them in store.
   *
   * @param {Object} context Vuex module context
   * @param {Object} payload payload
   * @param {Object} payload.family family group
   * @param {Object} payload.majorGroup major group
   * @param {Object} payload.question menu insight question
   *
   * @returns {Void}
   */
  fetchProductsByFamilyGroup: function fetchProductsByFamilyGroup(_ref17, _ref18) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var commit, getters, familyGroup, majorGroup, question, isMisc, productsPayload, res, products;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit = _ref17.commit, getters = _ref17.getters;
              familyGroup = _ref18.familyGroup, majorGroup = _ref18.majorGroup, question = _ref18.question;

              if (!getters.alreadyFetched({
                target: 'productsByFamilyGroup',
                refs: [familyGroup.ref, majorGroup.ref]
              })) {
                _context10.next = 4;
                break;
              }

              return _context10.abrupt("return");

            case 4:
              // reassign majorGroup with clone
              majorGroup = cloneDeep(majorGroup); // if ref 'misc', convert to null

              isMisc = majorGroup.isMisc;

              if (isMisc) {
                majorGroup.ref = null;
              }

              commit('setProductsByFamilyGroupLoading', {
                question: question,
                isLoading: true
              }); // get products

              productsPayload = {
                limit: 200,
                // TODO - this is only until pagination is implemented,
                offset: 0,
                familyGroupRef: familyGroup.ref,
                majorGroupRef: majorGroup.ref // text: null // only needed for text search, but leave here in case activated

              }; // fetch products from api

              _context10.next = 11;
              return Menu.getProducts(productsPayload);

            case 11:
              res = _context10.sent;

              // if misc, assign internal tracking reference to major group
              if (isMisc) {
                majorGroup.ref = 'misc' + familyGroup.ref;
              } // if products available, set in state


              if (res && Array.isArray(res.items)) {
                products = cloneDeep(res.items); // set products in both the cumulative allProducts array and by major and family groups

                commit('addToAllProducts', products);
                commit('addToProductsByQuestion', {
                  question: question,
                  products: products
                });
                commit('setProductsByFamilyGroup', {
                  familyGroup: familyGroup,
                  majorGroup: majorGroup,
                  products: products
                });
              }

              commit('setProductsByFamilyGroupLoading', {
                question: question,
                isLoading: false
              });

            case 15:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))();
  },

  /**
   * Fetch all products by major group via the API and set them in store.
   *
   * @param {Object} context Vuex module context
   * @param {Object} payload payload
   * @param {Object} payload.majorGroup major group
   * @param {Object} payload.question menu insight question
   *
   * @returns {Void}
   */
  fetchProductsByMajorGroup: function fetchProductsByMajorGroup(_ref19, _ref20) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var commit, getters, familyGroup, majorGroup, question, isMisc, productsPayload, res, products;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              commit = _ref19.commit, getters = _ref19.getters;
              familyGroup = _ref20.familyGroup, majorGroup = _ref20.majorGroup, question = _ref20.question;

              if (!getters.alreadyFetched({
                target: 'productsByMajorGroup',
                refs: [majorGroup.ref]
              })) {
                _context11.next = 4;
                break;
              }

              return _context11.abrupt("return");

            case 4:
              majorGroup = cloneDeep(majorGroup); // if ref 'misc', convert to null

              isMisc = majorGroup.isMisc;

              if (isMisc) {
                majorGroup.ref = null;
              }

              commit('setProductsByMajorGroupLoading', {
                question: question,
                isLoading: true
              }); // get products

              productsPayload = {
                limit: 200,
                // TODO - this is only until pagination is implemented,
                offset: 0,
                majorGroupRef: majorGroup.ref // text: null // only needed for text search, but leave here in case activated

              }; // fetch products from api

              _context11.next = 11;
              return Menu.getProducts(productsPayload);

            case 11:
              res = _context11.sent;

              // if misc, assign internal tracking reference to major group
              if (isMisc) {
                majorGroup.ref = 'misc' + familyGroup.ref;
              } // if products available, set in state


              if (res && Array.isArray(res.items)) {
                products = cloneDeep(res.items); // set products in both the cumulative allProducts array and by major and family groups

                commit('addToAllProducts', products);
                commit('addToProductsByQuestion', {
                  question: question,
                  products: products
                });
                commit('setProductsByMajorGroup', {
                  majorGroup: majorGroup,
                  products: products
                });
              }

              commit('setProductsByMajorGroupLoading', {
                question: question,
                isLoading: false
              });

            case 15:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }))();
  },

  /**
   * Fetch all products by search results via the API and set them in store.
   *
   * @param {Object} context Vuex module context
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Object} payload.value value
   * @param {Object} payload.mode MI mode
   *
   * @returns {Void}
   */
  fetchProductsBySearchResults: function fetchProductsBySearchResults(_ref21, _ref22) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      var commit, dispatch, state, getters, question, mode, value, productsPayload, res, products;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              commit = _ref21.commit, dispatch = _ref21.dispatch, state = _ref21.state, getters = _ref21.getters;
              question = _ref22.question, mode = _ref22.mode, value = _ref22.value;

              if (!getters.getSearchResultsLoading(question)) {
                _context12.next = 6;
                break;
              }

              return _context12.abrupt("return");

            case 6:
              commit('setSearchResultsLoading', {
                question: question,
                isLoading: true
              });

            case 7:
              // if no value provided, fetch it from waiting room
              if (!value) {
                value = state.searchWaitingRoom[question.id];
                commit('setSearchWaitingRoom', {
                  question: question,
                  value: null
                });
              } // if still no value, cancel search


              if (value) {
                _context12.next = 11;
                break;
              }

              commit('setSearchResultsLoading', {
                question: question,
                isLoading: false
              });
              return _context12.abrupt("return");

            case 11:
              // get products by search
              productsPayload = {
                limit: 200,
                // TODO - this is only until pagination is implemented,
                offset: 0,
                type: question.menuType,
                text: value
              }; // if family group mode, filter by family group ref

              if (question.mode === MENU_INSIGHT_MODE.FAMILY_GROUP) {
                productsPayload.familyGroupRef = question.menuFamilyGroupRef;
              } // if major group mode, filter by major group ref


              if (question.mode === MENU_INSIGHT_MODE.MAJOR_GROUP) {
                productsPayload.majorGroupRef = question.menuMajorGroupRef;
              } // fetch products from api


              _context12.next = 16;
              return Menu.getProducts(productsPayload);

            case 16:
              res = _context12.sent;

              if (res && Array.isArray(res.items)) {
                products = cloneDeep(res.items); // if products available, set in state (search results AND allProducts)

                commit('setProductSearchResults', {
                  question: question,
                  products: products
                });
                commit('addToProductsByQuestion', {
                  question: question,
                  products: products
                });
                commit('addToAllProducts', products);
              } // check if a value is in the waiting room, if so, don't keep it waiting!


              if (!state.searchWaitingRoom[question.id]) {
                _context12.next = 22;
                break;
              }

              commit('setSearchResultsLoading', {
                question: question,
                isLoading: false
              });
              dispatch('fetchProductsBySearchResults', {
                question: question,
                mode: mode
              });
              return _context12.abrupt("return");

            case 22:
              // perform final check to see if search cancelled, if so, clear out setProductSearchResults
              if (!state.searchResultsLoading) {
                commit('setProductSearchResults', {});
              } else {
                commit('setSearchResultsLoading', {
                  question: question,
                  isLoading: false
                });
              }

            case 23:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }))();
  }
});

var getters = _objectSpread(_objectSpread({}, make.getters(state)), {}, {
  // Make default getters

  /**
   * If the app is making use of the getters, the objects need to be created as needed
   * If the SPA is making the calls, get data from state
   */

  /**
   * Products
   */
  productsByType: function productsByType(state, getters, rootState, rootGetters) {
    if (!rootGetters['config/isApp']) {
      return state.productsByType;
    }

    return {}; // object with key = type value = object => key = family group ref, value = object => key = major group ref, value = products
    // const majorGroupsByFamilyGroupAndType = getters.majorGroupsByFamilyGroupAndType;
    // let productsByType = {};
    // Object.keys(majorGroupsByFamilyGroupAndType).forEach((key) => {
    //   productsByType[key] = {};
    //   Object.entries(majorGroupsByFamilyGroupAndType[key]).forEach(([famRef, majorGroups]) => {
    //     productsByType[key][famRef] = {};
    //     majorGroups.forEach((mg) => {
    //       productsByType[key][famRef][mg.ref] = mg.products
    //         .filter((product) => product.type === parseInt(key))
    //         .map((product) => ({
    //           name: product.name,
    //           type: product.type,
    //           ref: product.ref
    //         }));
    //     });
    //   });
    // });
    // return productsByType;
  },
  productsByFamilyGroup: function productsByFamilyGroup(state, getters, rootState, rootGetters) {
    if (!rootGetters['config/isApp']) {
      return state.productsByFamilyGroup;
    }

    return {}; // // productsByFamilyGroup[familyGroup.ref], majorGroup.ref, products
    // const majorGroupsByFamilyGroup = getters.majorGroupsByFamilyGroup;
    // let productsByFamilyGroup = {};
    // Object.keys(majorGroupsByFamilyGroup).forEach((key) => {
    //   productsByFamilyGroup[key] = {};
    //   Object.values(majorGroupsByFamilyGroup[key]).forEach((value) => {
    //     productsByFamilyGroup[key][value.ref] = value.products;
    //   });
    // });
    // return productsByFamilyGroup;
  },
  productsByMajorGroup: function productsByMajorGroup(state, getters, rootState, rootGetters) {
    if (!rootGetters['config/isApp']) {
      return state.productsByMajorGroup;
    }

    return {}; // productsByMajorGroup => majorGroup.ref, products
    // let productsByMajorGroup = {};
    // getters.majorGroups.forEach((majorGroup) => {
    //   productsByMajorGroup[majorGroup.ref] = majorGroup.products;
    //   return productsByMajorGroup;
    // });
    // return productsByMajorGroup;
  },

  /**
   * Family Groups
   */
  familyGroups: function familyGroups(state, getters, rootState, rootGetters) {
    if (!rootGetters['config/isApp']) {
      return state.familyGroups;
    }

    return state.downloadedProducts.familyGroups; // return state.allProducts;
  },
  familyGroupsByType: function familyGroupsByType(state, getters, rootState, rootGetters) {
    if (!rootGetters['config/isApp']) {
      return state.familyGroupsByType;
    }

    return {}; // return object with key = type, value => array of family groups with name, ref, weight
    // in order to sort allProducts we need to create a shallow copy since you cannot mutate an array from the store
    // const familyGroups = state.allProducts.slice().sort((a, b) => a.name.localeCompare(b.name));
    // // there are only three types
    // // create object of types (key) with family groups (value)
    // return {
    //   1: familyGroups.filter((x) => x.type.includes(1)),
    //   2: familyGroups.filter((x) => x.type.includes(2)),
    //   3: familyGroups.filter((x) => x.type.includes(3))
    // };
  },

  /**
   * Major Groups
   */
  majorGroups: function majorGroups(state, getters, rootState, rootGetters) {
    // if not app, get from state
    if (!rootGetters['config/isApp']) {
      return state.majorGroups;
    }

    return _this2.downloadedProducts.majorGroups; // // return all major groups, remove duplicates
    // return state.allProducts
    //   .filter((familyGroup) => familyGroup.majorGroups)
    //   .flatMap((familyGroup) =>
    //     familyGroup.majorGroups.map((majorGroup) => ({
    //       name: majorGroup.name,
    //       ref: majorGroup.ref,
    //       types: majorGroup.type,
    //       products: majorGroup.products
    //     }))
    //   )
    //   .filter(
    //     (majorGroup, index, self) => index === self.findIndex((mg) => mg.ref === majorGroup.ref)
    //   );
  },
  majorGroupsByFamilyGroup: function majorGroupsByFamilyGroup(state, getters, rootState, rootGetters) {
    // if not app, get from state
    if (!rootGetters['config/isApp']) {
      return state.majorGroupsByFamilyGroup;
    }

    return {}; // object with key = familyGroupRef, value = array with major groups
    // let majorGroupsByFamilyGroup = {};
    // getters.familyGroups.forEach((familyGroup) => {
    //   majorGroupsByFamilyGroup[familyGroup.ref] = familyGroup.majorGroups;
    //   return majorGroupsByFamilyGroup;
    // });
    // return majorGroupsByFamilyGroup;
  },
  majorGroupsByFamilyGroupAndType: function majorGroupsByFamilyGroupAndType(state, getters, rootState, rootGetters) {
    // if not app, get from state
    if (!rootGetters['config/isApp']) {
      return state.majorGroupsByFamilyGroupAndType;
    }

    return {}; // object with key = type value = object => key = familyGroupRef value = array with major groups
    // let majorByFamilyAndType = {};
    // Object.keys(getters.familyGroupsByType).forEach((key) => {
    //   majorByFamilyAndType[key] = {};
    //   getters.familyGroupsByType[key].forEach((fg) => {
    //     majorByFamilyAndType[key][fg.ref] = fg.majorGroups
    //       .filter((mg) => mg.type.includes(parseInt(key)))
    //       .map((mg) => ({
    //         name: mg.name,
    //         ref: mg.ref,
    //         type: mg.type,
    //         isMisc: mg.ref.includes('misc'),
    //         products: mg.products
    //       }));
    //   });
    // });
    // return majorByFamilyAndType;
  },

  /**
   * Checks if a target property has already been fetched, by ref(s)
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {String} payload.target target
   * @param {Array} payload.refs array of refs
   *
   * @returns {Boolean} True if already fetched
   */
  alreadyFetched: function alreadyFetched(state) {
    return function (_ref23) {
      var target = _ref23.target,
          refs = _ref23.refs;

      if (!target || !_typeof(target) === 'string' || !Array.isArray(refs) || !refs.length) {
        throw 'alreadyFetched arguments missing';
      }

      var fromState = state[target]; // if target invalid, throw error

      if (!fromState) {
        throw 'invalid target for alreadyFetched';
      } // return result of recursive existence check function when passed state variable and refs


      return goDeeper(fromState, refs, 'ref');
    };
  },

  /**
   * Gets the waiting room string for a particular question's search field
   *
   * @param {Object} state Vuex module state
   * @param {Object} question MI question
   *
   * @returns {String} Value in waiting room
   */
  getSearchWaitingRoom: function getSearchWaitingRoom(state) {
    return function (question) {
      return state.searchWaitingRoom[question.id];
    };
  },

  /**
   * Returns a particular mi question's family groups by a given type
   *
   * @param {Object} state Vuex module state
   * @param {String} type type id
   *
   * @returns {Array} family groups
   */
  getFamilyGroupsByType: function getFamilyGroupsByType(state) {
    return function (type) {
      return state.familyGroups[type] || [];
    };
  },

  /**
   * Checks if a particular mi question's familyGroupsByTypeLoading are loading
   *
   * @param {Object} state Vuex module state
   * @param {Object} question mi question
   *
   * @returns {Boolean} True if loading
   */
  getFamilyGroupsByTypeLoading: function getFamilyGroupsByTypeLoading(state) {
    return function (question) {
      return !!state.familyGroupsByTypeLoading[question.id];
    };
  },

  /**
   * Checks if a particular mi question's family groups are loading
   *
   * @param {Object} state Vuex module state
   * @param {Object} question mi question
   *
   * @returns {Boolean} True if loading
   */
  getFamilyGroupsLoading: function getFamilyGroupsLoading(state) {
    return function (question) {
      return !!state.familyGroupsLoading[question.id];
    };
  },

  /**
   * Checks if a particular mi question's major groups are loading
   *
   * @param {Object} state Vuex module state
   * @param {Object} question mi question
   *
   * @returns {Boolean} True if loading
   */
  getMajorGroupsLoading: function getMajorGroupsLoading(state) {
    return function (question) {
      return !!state.majorGroupsLoading[question.id];
    };
  },

  /**
   * Checks if a particular mi question's majorGroupsByFamilyGroupLoading are loading
   *
   * @param {Object} state Vuex module state
   * @param {Object} question mi question
   *
   * @returns {Boolean} True if loading
   */
  getMajorGroupsByFamilyGroupLoading: function getMajorGroupsByFamilyGroupLoading(state) {
    return function (question) {
      return !!state.majorGroupsByFamilyGroupLoading[question.id];
    };
  },

  /**
   * Checks if a particular mi question's majorGroupsByFamilyGroupAndTypeLoading are loading
   *
   * @param {Object} state Vuex module state
   * @param {Object} question mi question
   *
   * @returns {Boolean} True if loading
   */
  getMajorGroupsByFamilyGroupAndTypeLoading: function getMajorGroupsByFamilyGroupAndTypeLoading(state) {
    return function (question) {
      return !!state.majorGroupsByFamilyGroupAndTypeLoading[question.id];
    };
  },

  /**
   * Checks if a particular mi question's menu items are loading
   *
   * @param {Object} state Vuex module state
   * @param {Object} question mi question
   *
   * @returns {Boolean} True if loading
   */
  getAllProductsLoading: function getAllProductsLoading(state) {
    return function (question) {
      return !!state.allProductsLoading[question.id];
    };
  },

  /**
   * Checks if a particular mi question's productsByType are loading
   *
   * @param {Object} state Vuex module state
   * @param {Object} question mi question
   *
   * @returns {Boolean} True if loading
   */
  getProductsByTypeLoading: function getProductsByTypeLoading(state) {
    return function (question) {
      return !!state.productsByTypeLoading[question.id];
    };
  },

  /**
   * Checks if a particular mi question's productsByTransaction are loading
   *
   * @param {Object} state Vuex module state
   * @param {Object} question mi question
   *
   * @returns {Boolean} True if loading
   */
  getProductsByTransactionLoading: function getProductsByTransactionLoading(state) {
    return function (question) {
      return !!state.productsByTransactionLoading[question.id];
    };
  },

  /**
   * Checks if a particular mi question's productsByFamilyGroup are loading
   *
   * @param {Object} state Vuex module state
   * @param {Object} question mi question
   *
   * @returns {Boolean} True if loading
   */
  getProductsByFamilyGroupLoading: function getProductsByFamilyGroupLoading(state) {
    return function (question) {
      return !!state.productsByFamilyGroupLoading[question.id];
    };
  },

  /**
   * Checks if a particular mi question's productsByMajorGroup are loading
   *
   * @param {Object} state Vuex module state
   * @param {Object} question mi question
   *
   * @returns {Boolean} True if loading
   */
  getProductsByMajorGroupLoading: function getProductsByMajorGroupLoading(state) {
    return function (question) {
      return !!state.productsByMajorGroupLoading[question.id];
    };
  },

  /**
   * Checks if a particular mi question's search results are loading
   *
   * @param {Object} state Vuex module state
   * @param {Object} question mi question
   *
   * @returns {Boolean} True if loading
   */
  getSearchResultsLoading: function getSearchResultsLoading(state) {
    return function (question) {
      return !!state.searchResultsLoading[question.id];
    };
  }
});

var mutations = _objectSpread(_objectSpread({}, make.mutations(state)), {}, {
  // Make default mutations
  addMenuData: function addMenuData(state, menuData) {
    state.downloadedProducts = menuData;
  },

  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  },

  /**
   * Add products to allProducts in state
   *
   * @param {Object} state Vuex module state
   * @param {Array} products New products to add to state
   *
   * @returns {Void}
   */
  addToAllProducts: function addToAllProducts(state, products) {
    // set in state, but avoid duplicates
    var newProducts = cloneDeep(products) || [];
    var currentProducts = cloneDeep(state.allProducts) || [];
    var noDuplicates = newProducts.filter(function (i) {
      return !currentProducts.find(function (c) {
        return c.ref === i.ref;
      });
    });
    state.allProducts = [].concat(_toConsumableArray(currentProducts), _toConsumableArray(noDuplicates));
  },

  /**
   * Add family groups to familyGroups in state
   *
   * @param {Object} state Vuex module state
   * @param {Array} familyGroups New familyGroups to add to state
   *
   * @returns {Void}
   */
  addToFamilyGroups: function addToFamilyGroups(state, familyGroups) {
    // set in state, but avoid duplicates
    var newFamilyGroups = cloneDeep(familyGroups) || [];
    var currentFamilyGroups = cloneDeep(state.familyGroups) || [];
    var noDuplicates = newFamilyGroups.filter(function (i) {
      return !currentFamilyGroups.find(function (c) {
        return c.ref === i.ref;
      });
    });
    state.familyGroups = [].concat(_toConsumableArray(currentFamilyGroups), _toConsumableArray(noDuplicates));
  },

  /**
   * Add major groups to majorGroups in state
   *
   * @param {Object} state Vuex module state
   * @param {Array} majorGroups New majorGroups to add to state
   *
   * @returns {Void}
   */
  addToMajorGroups: function addToMajorGroups(state, majorGroups) {
    // set in state, but avoid duplicates
    var newMajorGroups = cloneDeep(majorGroups) || [];
    var currentMajorGroups = cloneDeep(state.majorGroups) || [];
    var noDuplicates = newMajorGroups.filter(function (i) {
      return !currentMajorGroups.find(function (c) {
        return c.ref === i.ref;
      });
    });
    state.majorGroups = [].concat(_toConsumableArray(currentMajorGroups), _toConsumableArray(noDuplicates));
  },

  /**
   * Add products to productsByQuestion in state
   *
   * @param {Object} state Vuex module state
   * @param {Array} products New products to add to state
   *
   * @returns {Void}
   */
  addToProductsByQuestion: function addToProductsByQuestion(state, _ref24) {
    var question = _ref24.question,
        products = _ref24.products;
    // set in state, but avoid duplicates
    var newProducts = cloneDeep(products) || [];
    var currentProducts = cloneDeep(state.productsByQuestion[question.id]) || [];
    var noDuplicates = newProducts.filter(function (i) {
      return !currentProducts.find(function (c) {
        return c.ref === i.ref;
      });
    });
    Vue.set(state.productsByQuestion, question.id, [].concat(_toConsumableArray(currentProducts), _toConsumableArray(noDuplicates)));
  },

  /**
   * Set allProducts in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Array} payload.allProducts All products
   *
   * @returns {Void}
   */
  setAllProducts: function setAllProducts(state, _ref25) {
    var allProducts = _ref25.allProducts;
    state.allProducts = allProducts;
  },

  /**
   * Set allProductsLoading in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Boolean} payload.isLoading true if loading
   *
   * @returns {Void}
   */
  setAllProductsLoading: function setAllProductsLoading(state, _ref26) {
    var question = _ref26.question,
        isLoading = _ref26.isLoading;
    Vue.set(state.allProductsLoading, question.id, isLoading);
  },

  /**
   * Set family groups in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Array} payload.familyGroups Family Groups
   *
   * @returns {Void}
   */
  setFamilyGroups: function setFamilyGroups(state, familyGroups) {
    state.familyGroups = familyGroups;
  },

  /**
   * Set family groups by type in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {String} payload.type type reference
   * @param {Array} payload.familyGroups family groups associated with the type
   *
   * @returns {Void}
   */
  setFamilyGroupsByType: function setFamilyGroupsByType(state, _ref27) {
    var type = _ref27.type,
        familyGroups = _ref27.familyGroups;
    Vue.set(state.familyGroupsByType, type, cloneDeep(familyGroups));
  },

  /**
   * Set familyGroupsLoading in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Boolean} payload.isLoading true if loading
   *
   * @returns {Void}
   */
  setFamilyGroupsLoading: function setFamilyGroupsLoading(state, _ref28) {
    var question = _ref28.question,
        isLoading = _ref28.isLoading;
    Vue.set(state.familyGroupsLoading, question.id, isLoading);
  },

  /**
   * Set setFamilyGroupsByTypeLoading in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Boolean} payload.isLoading true if loading
   *
   * @returns {Void}
   */
  setFamilyGroupsByTypeLoading: function setFamilyGroupsByTypeLoading(state, _ref29) {
    var question = _ref29.question,
        isLoading = _ref29.isLoading;
    Vue.set(state.familyGroupsByTypeLoading, question.id, isLoading);
  },

  /**
   * Set major groups in state
   *
   * @param {Object} state Vuex module state
   * @param {Array} majorGroups Major Groups
   *
   * @returns {Void}
   */
  setMajorGroups: function setMajorGroups(state, majorGroups) {
    state.majorGroups = cloneDeep(majorGroups);
  },

  /**
   * Set majorGroupsLoading in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Boolean} payload.isLoading true if loading
   *
   * @returns {Void}
   */
  setMajorGroupsLoading: function setMajorGroupsLoading(state, _ref30) {
    var question = _ref30.question,
        isLoading = _ref30.isLoading;
    Vue.set(state.majorGroupsLoading, question.id, isLoading);
  },

  /**
   * Set major groups by family in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.familyGroupRef family reference
   * @param {Array} payload.majorGroups major groups associated with the family
   *
   * @returns {Void}
   */
  setMajorGroupsByFamilyGroup: function setMajorGroupsByFamilyGroup(state, _ref31) {
    var familyGroupRef = _ref31.familyGroupRef,
        majorGroups = _ref31.majorGroups;
    Vue.set(state.majorGroupsByFamilyGroup, familyGroupRef, cloneDeep(majorGroups));
  },

  /**
   * Set major groups by family and type in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.familyGroupRef family reference
   * @param {Array} payload.majorGroups major groups associated with the family
   * @param {Array} payload.type menu type
   *
   * @returns {Void}
   */
  setMajorGroupsByFamilyGroupAndType: function setMajorGroupsByFamilyGroupAndType(state, _ref32) {
    var familyGroupRef = _ref32.familyGroupRef,
        majorGroups = _ref32.majorGroups,
        type = _ref32.type;

    // if no type level, set it
    if (!state.majorGroupsByFamilyGroupAndType[type]) {
      Vue.set(state.majorGroupsByFamilyGroupAndType, type, {});
    }

    Vue.set(state.majorGroupsByFamilyGroupAndType[type], familyGroupRef, cloneDeep(majorGroups));
  },

  /**
   * Set majorGroupsByFamilyGroupLoading in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Boolean} payload.isLoading true if loading
   *
   * @returns {Void}
   */
  setMajorGroupsByFamilyGroupLoading: function setMajorGroupsByFamilyGroupLoading(state, _ref33) {
    var question = _ref33.question,
        isLoading = _ref33.isLoading;
    Vue.set(state.majorGroupsByFamilyGroupLoading, question.id, isLoading);
  },

  /**
   * Set majorGroupsByFamilyGroupAndTypeLoading in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Boolean} payload.isLoading true if loading
   *
   * @returns {Void}
   */
  setMajorGroupsByFamilyGroupAndTypeLoading: function setMajorGroupsByFamilyGroupAndTypeLoading(state, _ref34) {
    var question = _ref34.question,
        isLoading = _ref34.isLoading;
    Vue.set(state.majorGroupsByFamilyGroupAndTypeLoading, question.id, isLoading);
  },

  /**
   * Set productsByType in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {String} payload.type product type
   * @param {Object} payload.familyGroup family group
   * @param {Object} payload.majorGroup major group
   * @param {Array} payload.products products
   *
   * @returns {Void}
   */
  setProductsByType: function setProductsByType(state, _ref35) {
    var type = _ref35.type,
        familyGroup = _ref35.familyGroup,
        majorGroup = _ref35.majorGroup,
        products = _ref35.products;

    // for each level, create and track object if missing
    if (!state.productsByType[type]) {
      Vue.set(state.productsByType, type, {});
    }

    if (!state.productsByType[type][familyGroup.ref]) {
      Vue.set(state.productsByType[type], familyGroup.ref, {});
    }

    Vue.set(state.productsByType[type][familyGroup.ref], majorGroup.ref, products);
  },

  /**
   * Set productsByTransaction in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {String} payload.question MI Question
   * @param {Array} payload.products products
   *
   * @returns {Void}
   */
  setProductsByTransaction: function setProductsByTransaction(state, _ref36) {
    var question = _ref36.question,
        products = _ref36.products;
    Vue.set(state.productsByTransaction, question.id, products);
  },

  /**
   * Set productsByFamilyGroup in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.familyGroup family group
   * @param {Object} payload.majorGroup major group
   * @param {Array} payload.products products
   *
   * @returns {Void}
   */
  setProductsByFamilyGroup: function setProductsByFamilyGroup(state, _ref37) {
    var familyGroup = _ref37.familyGroup,
        majorGroup = _ref37.majorGroup,
        products = _ref37.products;

    // for each level, create and track object if missing
    if (!state.productsByFamilyGroup[familyGroup.ref]) {
      Vue.set(state.productsByFamilyGroup, familyGroup.ref, {});
    }

    Vue.set(state.productsByFamilyGroup[familyGroup.ref], majorGroup.ref, products);
  },

  /**
   * Set productsByMajorGroup in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.majorGroup major group
   * @param {Array} payload.products products
   *
   * @returns {Void}
   */
  setProductsByMajorGroup: function setProductsByMajorGroup(state, _ref38) {
    var majorGroup = _ref38.majorGroup,
        products = _ref38.products;
    Vue.set(state.productsByMajorGroup, majorGroup.ref, products);
  },

  /**
   * Set productsByFamilyGroupLoading in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Boolean} payload.isLoading true if loading
   *
   * @returns {Void}
   */
  setProductsByFamilyGroupLoading: function setProductsByFamilyGroupLoading(state, _ref39) {
    var question = _ref39.question,
        isLoading = _ref39.isLoading;
    Vue.set(state.productsByFamilyGroupLoading, question.id, isLoading);
  },

  /**
   * Set productsByMajorGroupLoading in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Boolean} payload.isLoading true if loading
   *
   * @returns {Void}
   */
  setProductsByMajorGroupLoading: function setProductsByMajorGroupLoading(state, _ref40) {
    var question = _ref40.question,
        isLoading = _ref40.isLoading;
    Vue.set(state.productsByMajorGroupLoading, question.id, isLoading);
  },

  /**
   * Set productsByTypeLoading in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Boolean} payload.isLoading true if loading
   *
   * @returns {Void}
   */
  setProductsByTypeLoading: function setProductsByTypeLoading(state, _ref41) {
    var question = _ref41.question,
        isLoading = _ref41.isLoading;
    Vue.set(state.productsByTypeLoading, question.id, isLoading);
  },

  /**
   * Set productsByTransactionLoading in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Boolean} payload.isLoading true if loading
   *
   * @returns {Void}
   */
  setProductsByTransactionLoading: function setProductsByTransactionLoading(state, _ref42) {
    var question = _ref42.question,
        isLoading = _ref42.isLoading;
    Vue.set(state.productsByTransactionLoading, question.id, isLoading);
  },

  /**
   * Set product search results in state
   *
   * @param {Object} state Vuex module state
   * @param {Array} payload payload
   * @param {Array} payload.question Question
   * @param {Array} payload.products Product search results
   *
   * @returns {Void}
   */
  setProductSearchResults: function setProductSearchResults(state, _ref43) {
    var question = _ref43.question,
        products = _ref43.products;
    Vue.set(state.productSearchResults, question.id, cloneDeep(products));
  },

  /**
   * Set searchResultsLoading in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.question MI question
   * @param {Boolean} payload.isLoading true if loading
   *
   * @returns {Void}
   */
  setSearchResultsLoading: function setSearchResultsLoading(state, _ref44) {
    var question = _ref44.question,
        isLoading = _ref44.isLoading;
    Vue.set(state.searchResultsLoading, question.id, isLoading);
  },

  /**
   * Set searchWaitingRoom search string in state
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload payload
   * @param {Object} payload.question question
   * @param {Boolean} payload.value search string
   *
   * @returns {Void}
   */
  setSearchWaitingRoom: function setSearchWaitingRoom(state, _ref45) {
    var question = _ref45.question,
        value = _ref45.value;
    Vue.set(state.searchWaitingRoom, question.id, value);
  },

  /**
   * Clear search related properties in state
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  clearSearchRelatedProperties: function clearSearchRelatedProperties(state) {
    var _defaultState = defaultState();

    state.productSearchResults = _defaultState.productSearchResults;
    state.searchResultsLoading = _defaultState.searchResultsLoading;
    state.searchWaitingRoom = _defaultState.searchWaitingRoom;
  }
});

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  namespaced: true
};